// src/constants.js

export const API_BASE_URL =
  "https://gcommerce-backend-88926ef301bb.herokuapp.com/api";

// export const API_BASE_URL = 'http://localhost:5000/api';
